export default __webpack_public_path__ + "static/media/schoolDate1.7920d090.png";